import { render, staticRenderFns } from "./TemplateContratoProposta.vue?vue&type=template&id=464a4898"
import script from "./TemplateContratoProposta.vue?vue&type=script&lang=js"
export * from "./TemplateContratoProposta.vue?vue&type=script&lang=js"
import style0 from "@core/scss/vue/libs/quill.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./TemplateContratoProposta.vue?vue&type=style&index=1&id=464a4898&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports